import React from 'react'
import { useTranslate, useInput } from 'react-admin'
import { Chip, FormControl, InputLabel, MenuItem, Select, SelectProps } from '@mui/material'
import { FilterIcon } from 'common/Icons'

import 'styles.scss'

interface Choice {
  id: string,
  name: string,
}

interface OutlinedSelectInputProps {
  source: string,
  choices: Choice[]
  label: string,
  alwaysOn: boolean,
  fieldProps?: SelectProps<string>,
}

export const OutlinedSelectInput = (props: OutlinedSelectInputProps) => {
  const { source } = props
  const { field } = useInput({ source: source })

  return <CustomSelectInput {...props} onChange={field.onChange} initValue={field.value}/>
}

interface CustomSelectInputProps {
  choices: Choice[]
  label: string,
  alwaysOn: boolean,
  fieldProps?: SelectProps<string>,
  initValue?: string
  onChange?: (value: string) => void
  clearable?: boolean
  fullWidth?: boolean
  skipTranslate?: boolean
}

export const CustomSelectInput = ({ choices, label, fieldProps, initValue, onChange, fullWidth, clearable = true, skipTranslate = false }: CustomSelectInputProps) => {
  const translate = useTranslate()
  const [selectedItem, setSelectedItem] = React.useState<string>(initValue || '')

  const handleItemSelect = (value: string) => {
    setSelectedItem(value)
    onChange && onChange(value)
  }

  return <FormControl className="custom-array-input margin" sx={fullWidth ? { minWidth: "100% !important" } : undefined}>
    <InputLabel id="profile" shrink>{label}</InputLabel>
    <Select
      {...fieldProps}
      notched
      fullWidth
      label={label}
      value={selectedItem}
      onChange={e => handleItemSelect(e.target.value)}
      renderValue={(selected) => (
        <div>
          {
            <Chip
              key={selected}
              className="big-chip"
              label={skipTranslate ? choices.find(c => c?.id === selected)?.name || "" : translate(choices.find(c => c?.id === selected)?.name || "")}
              onDelete={clearable ? () => { handleItemSelect('') } : undefined}
              deleteIcon={
                <FilterIcon
                  type="gray-x"
                  onMouseDown={(event) => event.stopPropagation()} />
              }
              sx={{ '& .MuiChip-label': {
                px: 1,
                pr: clearable ? 0.5 : 1
              } }}
            />
          }
        </div>
      )}
    >
      {choices.map(({ id, name }) => (
        <MenuItem key={id} value={id}>
          <Chip
            key={id}
            className="squere-chip"
            label={skipTranslate ? name : translate(name)}
          />
        </MenuItem>
      ))}
    </Select>
  </FormControl>
}